import React from "react";
import { Routes, Route } from "react-router-dom";
import { AdminLayout } from "@/admin/AdminLayout";
import { ResourceManager } from "@/admin/ResourceManager";
import { SingletonForm } from "@/admin/SingletonForm";
import { RESOURCES, SINGLETONS } from "@/admin/fields";
import Overview from "@/admin/pages/Overview";
import PrayerRequests from "@/admin/pages/PrayerRequests";
import ContactMessages from "@/admin/pages/ContactMessages";
import Users from "@/admin/pages/Users";

const AdminApp = () => (
  <AdminLayout>
    <Routes>
      <Route index element={<Overview />} />
      <Route path="ministry" element={<SingletonForm endpoint="ministry" config={SINGLETONS.ministry} />} />
      <Route path="church" element={<SingletonForm endpoint="church" config={SINGLETONS.church} />} />
      <Route path="giving" element={<SingletonForm endpoint="giving" config={SINGLETONS.giving} />} />
      <Route path="settings" element={<SingletonForm endpoint="settings" config={SINGLETONS.settings} />} />
      <Route path="prayer-requests" element={<PrayerRequests />} />
      <Route path="contact-messages" element={<ContactMessages />} />
      <Route path="users" element={<Users />} />
      {Object.entries(RESOURCES).map(([key, cfg]) => (
        <Route key={key} path={key} element={<ResourceManager resource={key} config={cfg} />} />
      ))}
    </Routes>
  </AdminLayout>
);

export default AdminApp;
